// Part of taxPages, split to keep files short; ../taxPages.ts merges the parts. Keys sit directly under taxPages.
export const en = {
  gstLib: {
    testConnectionHint:
      'Test connection: no GSP is connected yet, so this number was not registered on the GST portal.',
    otherCountries: 'Other countries',
    gstinShape: 'GSTIN is 15 characters: state code, PAN, entity number, Z and a check character',
    gstinState: '"{{code}}" is not a GST state code',
    gstinCheck: 'GSTIN check character does not match; check for a typing error',
    irnCancel: {
      duplicate: 'Duplicate',
      dataEntry: 'Data entry mistake',
      orderCancelled: 'Order cancelled',
      others: 'Others',
    },
    registration: {
      regular: 'Regular',
      composition: 'Composition',
      sezUnit: 'SEZ unit',
      casual: 'Casual taxable person',
      unregistered: 'Unregistered',
    },
    mode: { road: 'Road', rail: 'Rail', air: 'Air', ship: 'Ship' },
    vehicleReason: {
      breakdown: 'Breakdown',
      transhipment: 'Transhipment',
      firstTime: 'First time',
    },
    subSupply: {
      s1: 'Supply',
      s2: 'Import',
      s3: 'Export',
      s4: 'Job work',
      s5: 'For own use',
      s6: 'Job work returns',
      s7: 'Sales return',
      s8: 'Others',
      s9: 'SKD/CKD/lots',
      s10: 'Line sales',
      s11: 'Recipient not known',
      s12: 'Exhibition or fairs',
    },
  },
  gstForms: {
    gstinState: 'The GSTIN is registered in {{state}}.',
    chooseRegistration: 'A company with a GSTIN is registered: choose its registration type.',
    maxDistance: 'Distance is at most {{km}} km.',
    transDocDate: 'Enter the transport document date with its number.',
    vehicleOrTransporter:
      'Enter the vehicle number, the transport document, or the transporter ID for Part A only.',
    transporterNameLength: 'Transporter name is up to 100 characters.',
    vehicleNo: 'Enter the vehicle number.',
    transDocNo: 'Enter the railway receipt, airway bill or bill of lading number.',
    fromPlace: 'Enter the place where the vehicle changes.',
    fromState: 'Choose the state the vehicle changes in.',
  },
};

export const ar = {
  gstLib: {
    testConnectionHint:
      'اتصال تجريبي: لم يُربط أي مزوّد GSP بعد، لذلك لم يُسجَّل هذا الرقم على بوابة GST.',
    otherCountries: 'دول أخرى',
    gstinShape: 'يتكوّن GSTIN من 15 حرفًا: رمز الولاية، ورقم PAN، ورقم الكيان، والحرف Z، وحرف تحقق',
    gstinState: '"{{code}}" ليس رمز ولاية في GST',
    gstinCheck: 'حرف التحقق في GSTIN غير مطابق؛ تحقّق من وجود خطأ في الكتابة',
    irnCancel: {
      duplicate: 'مكرر',
      dataEntry: 'خطأ في إدخال البيانات',
      orderCancelled: 'أُلغي الطلب',
      others: 'أخرى',
    },
    registration: {
      regular: 'عادي',
      composition: 'نظام التسوية (Composition)',
      sezUnit: 'وحدة في منطقة اقتصادية خاصة',
      casual: 'خاضع للضريبة بصفة عرضية',
      unregistered: 'غير مسجّل',
    },
    mode: { road: 'بري', rail: 'سكك حديدية', air: 'جوي', ship: 'بحري' },
    vehicleReason: {
      breakdown: 'عطل',
      transhipment: 'إعادة شحن',
      firstTime: 'أول مرة',
    },
    subSupply: {
      s1: 'توريد',
      s2: 'استيراد',
      s3: 'تصدير',
      s4: 'تشغيل للغير',
      s5: 'للاستخدام الخاص',
      s6: 'مرتجعات التشغيل للغير',
      s7: 'مرتجع مبيعات',
      s8: 'أخرى',
      s9: 'SKD/CKD/دفعات',
      s10: 'مبيعات متنقلة',
      s11: 'المستلم غير معروف',
      s12: 'معارض',
    },
  },
  gstForms: {
    gstinState: 'رقم GSTIN مسجّل في {{state}}.',
    chooseRegistration: 'الشركة التي لديها GSTIN مسجّلة: اختر نوع تسجيلها.',
    maxDistance: 'المسافة {{km}} كم كحد أقصى.',
    transDocDate: 'أدخل تاريخ مستند النقل مع رقمه.',
    vehicleOrTransporter: 'أدخل رقم المركبة، أو مستند النقل، أو معرّف الناقل للجزء A فقط.',
    transporterNameLength: 'اسم الناقل 100 حرف كحد أقصى.',
    vehicleNo: 'أدخل رقم المركبة.',
    transDocNo: 'أدخل رقم إيصال السكك الحديدية أو بوليصة الشحن الجوي أو البحري.',
    fromPlace: 'أدخل المكان الذي تتغيّر فيه المركبة.',
    fromState: 'اختر الولاية التي تتغيّر فيها المركبة.',
  },
};
